import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParticipationHelpModalComponent } from './participation-help-modal.component';
import { ButtonModule } from '@xref/xref-lib';



@NgModule({
  declarations: [ParticipationHelpModalComponent],
  imports: [
    CommonModule,
    ButtonModule
  ],
  exports: [ParticipationHelpModalComponent]
})
export class ParticipationHelpModalModule { }
